/**
 * External dependencies
 */
import { GroupContainerIcon, UngroupContainerIcon } from '~stackable/icons'

/**
 * WordPress dependencies
 */
import { Icon } from '@wordpress/components'

export const Group = <Icon icon={ GroupContainerIcon } />
export const Ungroup = <Icon icon={ UngroupContainerIcon } />

